import React from "react";
import "../css/Home.css";
import Header from "./CHeader";

const PageNotFound = () => {
    return (
        <div>
            <Header isTos={false} />
            <div className="container mt card cd">
                <p>
                    Pardon our progress, but the <b>Terms of Use</b> process has changed.
                    You no longer need to use this form to accept - simply use the credentials or
                    guest join link sent to you in email.
                    The Terms of Use will prompt for acceptance during login whenever required - typically on your
                    first login to the environment or whenever the Terms of Use themselves change.
                </p>
            </div>
        </div >
    );
}

export default PageNotFound;